import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvalidFieldComponent } from 'src/app/shared/components';
import { BackButtonComponent } from 'src/app/shared/components/back-button/back-button.component';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { PasswordRecoveryMaterialModule } from './password-recovery-material-modules.module';
import { RecoveryPasswordComponent } from './password-recovery.component';

@NgModule({
    imports: [
        CommonModule,
        LogoFacilityComponent,
        ReactiveFormsModule,
        FormsModule,
        PasswordRecoveryMaterialModule,
        BackButtonComponent,
        InvalidFieldComponent,
    ],
    declarations: [RecoveryPasswordComponent],
    exports: [RecoveryPasswordComponent],
})
export class PasswordRecoveryModule {}
